import { render } from "./checkboxs-radios.vue?vue&type=template&id=24474741"
import script from "./checkboxs-radios.vue?vue&type=script&lang=js"
export * from "./checkboxs-radios.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__